import React from 'react'
import './BusinessFAQCard.scss'

/*
  Контактная плитка: заголовок и ссылка-действие. Рамки раньше гасились
  инлайновыми style, теперь это обычная плитка без них.
*/
const BusinessFAQCard = ({title, subTitle, img, link}) => {
  return (
    <div className='businessFAQCard_block'>
      <h3>{title}</h3>
      <a className="businessFAQCard_item" href={link || '#form'}>
        {/* Иконка одноцветная: рисуем маской, цвет — как у текста ссылки,
            иначе в обеих темах она читалась как тёмное пятно. */}
        <span className="businessFAQCard_icon" style={{ '--icon': `url("${img}")` }} aria-hidden="true" />
        <span>{subTitle}</span>
      </a>
    </div>
  )
}

export default BusinessFAQCard
